import { Col, Container, Row } from 'react-bootstrap'
import { HeaderTitle } from '../../common/HeaderTitle.jsx'
import { Input } from '../../common/inputs'
import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useUprawnienia } from '../../../api/domain/osoby/queries/useUprawnienia.jsx'

const ViewMojeUprawnienia = () => {
    const kcId = useSelector((store) => store?.user?.user?.sub)
    const { data } = useUprawnienia(Boolean(kcId), kcId)
    const [searchTerm, setSearchTerm] = useState('')
    const mojeUprawnienia = useMemo(() => {
        if (Array.isArray(data)) {
            return data
        }

        if (Array.isArray(data?.perms)) {
            return data.perms
        }

        if (Array.isArray(data?.uprawnienia)) {
            return data.uprawnienia
        }

        return []
    }, [data])

    const normalizedSearch = searchTerm.trim().toLowerCase()
    const resultsList = useMemo(() => {
        if (!normalizedSearch) {
            return mojeUprawnienia
        }

        return mojeUprawnienia.filter((item) =>
            item?.toLowerCase?.().includes(normalizedSearch)
        )
    }, [mojeUprawnienia, normalizedSearch])

    return (
        <>
            <HeaderTitle size={'h2'} nav={true} destination={'/'} title={'Moje uprawnienia'} />
            <Container>
                <HeaderTitle
                    nav={false}
                    size={'h3'}
                    title={'Lista Twoich uprawnien'}
                />
            </Container>

            <Container>
                <Row className={'me-5'}>
                    <Input
                        label={`Przeszukaj swoja liste uprawnien${resultsList.length ? ` (${resultsList.length})` : ''}`}
                        onChange={(event) => setSearchTerm(event?.target?.value || '')}
                        value={searchTerm}
                    />
                    <Col>
                        <div className={'mt-2 w-100 float-start'}>
                            {resultsList.length ? (
                                resultsList.map((item, idx) => (
                                    <div className={'text-start my-1 p-1 bg-light'} key={idx}>
                                        {item}
                                    </div>
                                ))
                            ) : (
                                <div className={'text-start my-1 p-1 bg-light'}>
                                    Brak uprawnien do wyswietlenia.
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ViewMojeUprawnienia
